import { useCallback, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { thunks as regionSvc } from "src/thunks/region";

export const useInitialize = () => {
  // const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);

  const initialize = useCallback(async () => {
    // await dispatch(regionSvc.getSidos());
    // await dispatch(regionSvc.getSidosNames());
    // config는 각자 들고 오는것으로 변경
    // await dispatch(configSvc.getAllMyConfig());
    setIsInitialized(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-undef
  useEffect(
    () => {
      initialize();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return isInitialized;
};
